module.exports = __webpack_public_path__ + "static/img/no_recommand.23fdb391.png";